module.exports = __webpack_public_path__ + "static/media/bride-2-min.05603064.jpg";